export default "__VITE_ASSET__CxQtZ7xh__"